<mat-icon
  [matTooltip]="
    (isManagerOverwritten
      ? 'employee-profile.sections.management.manager-overwritten-info'
      : 'employee-profile.sections.management.manager-calculated-info'
    ) | translate
  "
  [class.overwritten]="isManagerOverwritten">
  {{ isManagerOverwritten ? 'warning' : 'info' }}
</mat-icon>
